import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20Chinese%20mahjong%20tiles%20scattered%20on%20a%20warm%20dark%20wooden%20surface%20with%20soft%20ambient%20lighting%2C%20traditional%20Chinese%20pattern%20elements%20subtly%20blended%20in%20background%2C%20elegant%20composition%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20depth%20of%20field%20effect%2C%20artistic%20photography%20style&width=1600&height=900&seq=mahjong-hero-01&orientation=landscape"
          alt="麻将在线玩 - 免费畅玩正宗麻将游戏"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          {t('hero.title')}
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-3 font-heading">
          {t('hero.subtitle')}
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-2xl mx-auto">
          {t('hero.description')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/xinshou-rumen"
            className="px-8 py-3 rounded-md bg-primary-500 text-white font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
          >
            {t('hero.cta')}
          </Link>
          <Link
            to="/category/guobiao-majiang"
            className="px-8 py-3 rounded-md border border-white/40 text-white font-medium text-sm whitespace-nowrap hover:bg-white/10 transition-all duration-200"
          >
            了解玩法
          </Link>
        </div>
      </div>
    </section>
  );
}